import React, {useEffect, useState} from "react";
import Rating from 'react-rating-stars-component';
import {useNavigate, useParams} from "react-router-dom";
import logo from "../assets/logo.png";
import mess from "../assets/message.png"
import like from "../assets/heart.png"
import dislike from "../assets/close.png"
import handlePersonData from "../services/handlePersonData";



function Person() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [data,setData] = useState({})
    const [rank,setRank] = useState(0)
    const [star,setStar] = useState(0)

    const [loading,setLoading] = useState(false)

    const countLike = JSON.parse(localStorage.getItem('count_like'))
    const countRank = JSON.parse(localStorage.getItem('count_rank'))
    const countChat = JSON.parse(localStorage.getItem('count_chat'))

    const getRandomPerson = () => {
        const newId = Math.floor(Math.random() * 30) + 1;
        navigate(`/carboncopydating/person/${Number(newId)}`)
    };


    // Create an array of image paths based on the id
    const added_images = [];
    for (let i = 1; i <= 12; i++) {
        try {
            added_images.push(require(`../assets/added_photo/${id}/${i}.png`));
        } catch (err) {
            // Break the loop if the image does not exist
            break;
        }
    }



    useEffect(() => {
        if(localStorage.getItem("count_like")?.length<38){
            localStorage.clear();
        }
        if(!localStorage.getItem('count_like') || !localStorage.getItem('count_rank')  || !localStorage.getItem('count_chat') ){
            const count_like ={}
            const count_rank ={}
            const count_chat ={}
            for (let i = 0; i <= 50; i++) {
                count_like[i] = [0,0]; //like,dislike
                count_rank[i] = [0,0]; //score,cnt
                count_chat[i] = 0;
            }
            localStorage.setItem('count_like', JSON.stringify(count_like));
            localStorage.setItem('count_rank', JSON.stringify(count_rank));
            localStorage.setItem('count_chat', JSON.stringify(count_chat));
        }
    }, []);


    const getNextNumber = (currentNumber) => {
        const id_list = [31,32,33,34,35,36,37,38,11,3,20,24,15,30,21,10,17,25,2,22,19,7,29,6,27,26,8,9,23,28,4,16,18,1,13,12,5,14];
        const currentIndex = id_list.indexOf(Number(currentNumber));
        if (currentIndex !== -1) {
            const nextIndex = (currentIndex + 1) % id_list.length;
            return id_list[nextIndex];
        } else {
            return 31; // 如果当前数字不在数组中，则返回 null 或者其他你认为合适的值
        }
    }
    const getNextPerson = () => {
        const newId = getNextNumber(id)
        navigate(`/carboncopydating/person/${Number(newId)}`)
    };




    const handleBeautyRankingChange =(rating)=>{
        countRank[id][1]=countRank[id][1]+1
        countRank[id][0]=((countRank[id][1]-1)*countRank[id][0]+rating)/countRank[id][1]

        // 将 key-value 对转换为数组并按照 value 排序
        const sortedArray = Object.entries(countRank).sort((a, b) => b[1][0] - a[1][0]);

        // 为每个 key-value 对添加排名
        const rankedArray = sortedArray.map((entry, index) => ({
            key: entry[0],
            value: entry[1],
            rank: index + 1,
        }));
        setRank(rankedArray?.find((entry) => entry.key === id)?.rank)
        localStorage.setItem('count_rank', JSON.stringify(countRank));
    }

    const setBeautyRanking =()=>{
        // 将 key-value 对转换为数组并按照 value 排序
        const sortedArray = Object.entries(countRank).sort((a, b) => b[1][0] - a[1][0]);

        // 为每个 key-value 对添加排名
        const rankedArray = sortedArray.map((entry, index) => ({
            key: entry[0],
            value: entry[1],
            rank: index + 1,
        }));
        setRank(rankedArray?.find((entry) => entry.key === id)?.rank)
    }




    useEffect(() => {
        const getNewData = async () => {
            const newData = await handlePersonData(id)
            setData(newData)
        }
        setBeautyRanking()
        getNewData()
        setLoading(false)
    }, [id]);




    return (
        <div className="home">
            <div className="home-left">
                <div className="person-header" style={{cursor:'pointer'}} onClick={() => navigate('/carboncopydating')}>
                    <img src={logo} width={52} style={{marginRight:20,marginTop:8}} onClick={()=>navigate('/carboncopydating')}/>
                    carbon copy
                </div>
                <div className="person-info-card">
                    <div className="person-title-3">
                        {/*<div className="person-title-1">*/}
                        {/*    Attractiveness Meter : {countRank[id] && countRank[id].length > 1*/}
                        {/*    ? (countRank[id][1] === 0 ? "no data" : (rank / 31 * 100).toFixed(2) + "%")*/}
                        {/*    : "no data"}*/}
                        {/*</div>*/}

                        <div className="person-title-1">
                            NAME: {data.name}
                        </div>

                        <img src={data?.photo?.url ?? logo} style={{ objectFit: "cover",width:"80%",margin:24,borderRadius:24}}/>
                        {/*<div>*/}
                        {/*    NAME: {data.name}*/}
                        {/*</div>*/}
                        <div>
                            AGE: {data.age}
                        </div>
                        <div>
                            GENDER: {data.gender}
                        </div>
                        <div >
                            OCCUPATION: {data.occupation}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{width: "60%"}}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    margin: "48px 48px 48px 12px",
                }}>
                    <div className="person-content">
                        {
                            data?.introduction?.split('\n').map((paragraph, index) => (
                                <p style={{margin:"18px 6px"}}>{paragraph}</p>
                            ))
                        }
                        <div className="photo-gallery">
                            {added_images.map((src, index) => (
                                <img  src={src} alt={`Additional ${index + 1}`} key={index} className="added-photo" />
                            ))}
                        </div>

                    </div>

                    <div className="fixed-button">
                        <div className="person-title-1">
                            Attractiveness Meter
                        </div>
                        <div className="fixed-button">
                            <Rating
                                count={5}
                                onChange={(rating) => {
                                    setStar(rating);
                                    handleBeautyRankingChange(rating)
                                }}
                                size={24}
                                color="#DEDEDE"
                                activeColor="#FFCE0A"
                                value={star}
                            />
                        </div>
                    </div>
                    <div class="fixed-button">
                        <div className="buttom-grey" style={{width:100,display:"flex",justifyContent:'center',alignItems:'center',color:"#151515"}} onClick={() => {
                            setLoading(true)
                            countLike[id][1] = countLike[id][1] + 1;
                            localStorage.setItem('count_like', JSON.stringify(countLike));
                            getNextPerson()
                        }}>
                            {/*<img src={dislike} width={36} style={{margin:3,height:36}} /> */}
                            Next
                        </div>

                        <button className="buttom-pink" style={{width:200,display:"flex",justifyContent:'center',alignItems:'center'}} onClick={() => {
                            setLoading(true)
                            countLike[id][0] = countLike[id][0] + 1;
                            localStorage.setItem('count_like', JSON.stringify(countLike));
                            getNextPerson()
                        }}>
                            <img src={like} width={40} style={{margin:5,marginRight:12}} />
                            Like
                        </button>


                        <div className="buttom-grey" style={{width:100,display:"flex",justifyContent:'center'}} onClick={() => {
                            setLoading(true)
                            countChat[id] = countChat[id] + 1;
                            localStorage.setItem('count_chat', JSON.stringify(countChat));
                            // navigate(`/carboncopydating/chat/${Number(id)}`)
                            window.alert("This function is disabled now")
                        }}>
                            <img src={mess} style={{width: 50, height: 50}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Person;
